import { render, staticRenderFns } from "./TradingProductDropdownField.vue?vue&type=template&id=005131d5"
import script from "./TradingProductDropdownField.vue?vue&type=script&lang=ts"
export * from "./TradingProductDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005131d5')) {
      api.createRecord('005131d5', component.options)
    } else {
      api.reload('005131d5', component.options)
    }
    module.hot.accept("./TradingProductDropdownField.vue?vue&type=template&id=005131d5", function () {
      api.rerender('005131d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/TradingProductDropdownField.vue"
export default component.exports